import React, { Component } from 'react';
import {InputGroup, Button, MenuItem, DropdownButton, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import locales from './Locales.js';


class TimeIO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: '',
      inputValue: '',
      outputValue: '',
      localeDropDown: 'en-us',
      localeString: '',
      parseString: {
        inputValue: '',
        inputLabel: 'ISO-8601',
        outputValue: '',
        outputLabel: 'Epoch (milliseconds)',
        dateToEpoch: true,
        label: {
          true: 'Parse ISO-8601 to Epoch',
          false: 'Parse Epoch to ISO-8601'
        }
      },
      currentEpoch: (new Date).getTime(),
      currentISO8601: ''
    };
    this.handleDropDownChange = this.handleDropDownChange.bind(this);
    this.handleSwapInputOutput = this.handleSwapInputOutput.bind(this);
    this.handleCopyToClipboard = this.handleCopyToClipboard.bind(this);
    this.handleUseAsInput = this.handleUseAsInput.bind(this);
    this.handleParseStringInput = this.handleParseStringInput.bind(this);
    this.getParseStringOutput = this.getParseStringOutput.bind(this);
    this.setStateTime = this.setStateTime.bind(this);
  }

  handleUseAsInput(event) {
    let tmp = ''
    if (event.target.value === 'iso') {
      let d = new Date();
      tmp = d.toISOString();
    } else {
        tmp = (new Date).getTime();
    }
    this.handleParseStringInput({target: {value: tmp}});
    // this.setState({...this.state, parseString:{...this.state.parseString, inputValue: (new Date).getTime()}})
  }

  getParseStringOutput(dateToEpoch, inputValue) {
    inputValue = inputValue.toString();
    let tmp_response = ''
    if (dateToEpoch === true) {

      tmp_response = inputValue === '' ? '' : Date.parse(inputValue);
    } else {
      let seconds = inputValue.substr(0, inputValue.length - 3);
      let milliseconds = inputValue.substr(inputValue.length - 3)
      var d = new Date(0);
      d.setUTCSeconds(seconds, milliseconds);
      tmp_response = inputValue === '' ? '' : d
    }
    return tmp_response
  }

  handleParseStringInput(event) {
    let tmpOutputValue = this.getParseStringOutput(this.state.parseString.dateToEpoch, event.target.value)
    // I think I need a method that gives me the epoch and a method that gives me iso-8601
    this.setState({...this.state, localeString: this.epochToLocale(this.inputAsEpoch(event.target.value), this.state.localeDropDown), parseString: {...this.state.parseString, inputValue: event.target.value, outputValue: tmpOutputValue}});
  }

  handleSwapInputOutput(event) {
    this.setState({...this.state, localeString: this.epochToLocale(this.inputAsEpoch(this.state.parseString.inputValue), this.state.localeDropDown), parseString: {...this.state.parseString, inputLabel: this.state.parseString.outputLabel, outputLabel: this.state.parseString.inputLabel, dateToEpoch: !this.state.parseString.dateToEpoch, outputValue: this.getParseStringOutput(!this.state.parseString.dateToEpoch, this.state.parseString.inputValue)}})
  }

  epochStringToEpochInteger(epochString) {
    return parseInt(epochString, 10);
  }

  epochToLocale(epoch, locale) {
    epoch = parseInt(epoch, 10);
    return new Date(epoch).toLocaleString(locale)
  }

  inputAsEpoch(inputValue = this.state.parseString.inputValue, dateToEpoch = this.state.parseString.dateToEpoch) {
    let tmp_response = '';
    if (dateToEpoch === true) {
      tmp_response = inputValue === '' ? '' : Date.parse(inputValue);
    } else {
      tmp_response = inputValue;
    }
    return tmp_response;
  }

  handleDropDownChange(event) {
    this.setState({localeDropDown: event, localeString: this.epochToLocale(this.inputAsEpoch(), event)})
  }

  setStateTime() {
    let d = new Date();
    let n = d.toISOString();
    this.setState({currentEpoch: (new Date).getTime(), currentISO8601: n});
  }

  handleCopyToClipboard() {
    let inp = document.querySelector('#hiddenable');
    inp.style.display = 'block';
    if (inp && inp.select) {
      inp.select();
      document.execCommand('copy');
      inp.blur();
      inp.style.display = 'none';
    } else {
      console.log();
    }
  }

  componentDidMount() {
    let tmp = window.setInterval(() => { this.setStateTime(); }, 2)
    this.setState({intervalId: tmp});
  }

  componentWillUnmount() {
    window.clearInterval(this.state.intervalId);
  }

  render() {
    return (
      <div>
        <div className="top-buffer">
          <h2><code className="shell">current epoch (milliseconds): <span id="copyable">{ this.state.currentEpoch }</span></code></h2><input id="hiddenable" type="text" style={{'display': 'none'}} value={this.state.currentEpoch} />
        </div>
        <div className="top-buffer">
          <Button bsStyle="default" onClick={this.handleCopyToClipboard} bsSize="xsmall">Copy to Clipboard</Button>
          <Button bsStyle="default" onClick={this.handleUseAsInput} value="epoch" bsSize="xsmall">Use as Input Below</Button>
        </div>

        <div className="top-buffer">
          <h2><code className="shell">current ISO-8601: <span id="copyable">{ this.state.currentISO8601 }</span></code></h2><input id="hiddenable" type="text" style={{'display': 'none'}} value={this.state.currentEpoch} />
        </div>
        <div className="top-buffer">
          <Button bsStyle="default" onClick={this.handleCopyToClipboard} bsSize="xsmall">Copy to Clipboard</Button>
          <Button bsStyle="default" onClick={this.handleUseAsInput} value="iso" bsSize="xsmall">Use as Input Below</Button>
        </div>

        <FormGroup controlId="formControlsTextarea" className="top-buffer">
          <ControlLabel>{this.state.parseString.label[this.state.parseString.dateToEpoch]}</ControlLabel>
          <FormGroup>
            <InputGroup>
              <InputGroup.Button>
                <Button>Input : {this.state.parseString.inputLabel}</Button>
              </InputGroup.Button>
              <FormControl value={this.state.parseString.inputValue} onChange={this.handleParseStringInput} type="text" />
            </InputGroup>
          </FormGroup>

          <FormGroup>
            <InputGroup>
              <InputGroup.Button>
                <Button>Output : {this.state.parseString.outputLabel}</Button>
              </InputGroup.Button>
              <FormControl type="text" value={this.state.parseString.outputValue} />
            </InputGroup>
          </FormGroup>

          <div className="top-buffer">
            <Button bsStyle="default" onClick={this.handleSwapInputOutput} bsSize="xsmall">Swap Input/Output</Button>
          </div>

        </FormGroup>

        <FormGroup controlId="formControlsTextarea" className="top-buffer">
          <ControlLabel>Input String as Locale</ControlLabel>
          <InputGroup>
              <DropdownButton componentClass={InputGroup.Button} title={this.state.localeDropDown} id={`dropdown-basic-1`}>
                {
                  locales.map((locale, index) => (
                    <MenuItem onSelect={this.handleDropDownChange} key={index} eventKey={locale}>{locale}</MenuItem>
                  ))
                }
              </DropdownButton>
              <FormControl type="text" value={this.state.localeString}/>
          </InputGroup>

        </FormGroup>
      </div>
    );
  }
}

export default TimeIO;



// WEBPACK FOOTER //
// ./src/components/TimeIO/TimeIO.js